import React, { useEffect, useState } from "react";
import { Select, Row, Col, Form, Input, Radio, InputNumber, Space, Switch } from "antd";
import {MrSelect,  FormRenderer } from "mr_react_framework";
import moment from 'moment';
import dayjs from 'dayjs';
import {actions as genericActions} from "App/genericRedux";
import { GenericWidgetCreator, SelectGrade as SelectOrgGrade, SelectSubject as SelectOrgSubject, SelectProgrammeSubject, SelectProgrammeGrade, SelectProgram, SelectRubric, SelectPaperType, SelectTeachingLevel, SelectStandardCollectionContentArea }  from "components/AppSpecific/SelectSubject/SelectSubject"
import MrTranslate, { mrTranslate, useTranslate } from "lib/MrTranslate/MrTranslate"
import { buildOptionsArr, checkMob, createUpdateSelectAttrsBeforeSubmit } from "lib/utils/helperMethods";
import { getAssessmentTypeOptionsForForm, getExperienceModeOptionsForForm } from "../ExperienceHelperMethods";
import { useSelector } from "react-redux";
import { enabledFeaturesSelector } from "views/Auth/Login/selector";
import { activeAdjustedExperienceSelector } from "../selector";
import { rubricsSelector } from "views/Rubrics/Selector";
import RubricCriteriaPointsForm from "views/Segments/RubricCriteriaPointsForm/RubricCriteriaPointsForm";
import { isEmpty } from "lodash";

const segmentConfig = {
  createMode: true,
  editMode: false,
  autoCheckMode: false,
}
const CustomSwitchWidget = (props) => {
  console.log("CustomSwitchWidget props", props);
  return (
    <Space>
      <Switch {...props} /> <label>{props.placeholder}</label>
    </Space>
  );
};

const SelectQuestionbank = MrSelect({
  actions: genericActions,
  resourceName: "questionbanks",
  config: {
    url: "/questionbanks",
    // params: { key: "value" },
    processData: (data, props) => {
      return data.map((item) => {
        return { label: item.title, value: item.id };
      });
    },
    widgetConfig: {
      showSearch: false, // if false, this will either load entire data from backend on widget load or onSearch
      // TBD: If false, need to be able to search. Also if can do regular select from redux with this component, then can use same everywhere.
      // placeholder: "Select questionbank",
      placeholder: <MrTranslate id={"CommonText.select_questionbank"} />
      // mode: "multiple",
      // style: { width: "300px" },
    },
  },
});

const SelectLearningOutcomes = MrSelect({
  actions: genericActions,
  resourceName: "learningoutcomes",
  config: {
    url: "/learningoutcomes",
    // params: { key: "value" },
    processData: (data, props) => {
      return data.map((item) => {
        return { label: item.title, value: item.id };
      });
    },
    searchApi: true,
    widgetConfig: {
      showSearch: true, // if false, this will either load entire data from backend on widget load or onSearch
      // TBD: If false, need to be able to search. Also if can do regular select from redux with this component, then can use same everywhere.
      placeholder: <MrTranslate id={"ExperienceCreateForm.select_los"} />,
      mode: "multiple",
      // style: { width: "300px" },
    },
  },
});

const SelectStandardCollectionContentAreaWidget = GenericWidgetCreator((props) => {
  console.log("SelectStandardCollectionContentAreaWidget", props)
  let params = {}
  let subjectId = props.formInstance.getFieldValue(["relation_items", "0", "subject_id"])
  params = {by_programme_subject_id: subjectId }
  return {config: {forceReload: true, params: params}}
}, SelectStandardCollectionContentArea);

const getStandardCollectionContentAreaField = (sourceValues, mrIntl) => {
  console.log("getStandardCollectionContentAreaField sourceValues", sourceValues)
  return {
    type: "object",
    properties: {
      standard_collection_content_area_tag_ids: {
        type: "string",
        // title: "Standard content area",
        placeholder: "Standard content area",
        widget: SelectStandardCollectionContentAreaWidget,
        widgetConfig: {
          disabled: sourceValues.standard_collection_content_area_tag_ids
        },
        // rules: [
        //   {
        //     required: true,
        //     message: mrIntl("CommonText.required_msg"),
        //   },
        // ],
        setInitialValue: true,
      },
    }
  }
};

const SelectStandardCollectionContentAreaChildComponent = ({getFieldValue, sourceValues, formInstance, setFieldsValue}) => {
  console.log("SelectStandardCollectionContentAreaChildComponent sourceValues", sourceValues);
  const subjectId = getFieldValue(["relation_items", "0", "subject_id"]);
  
  let finalRender = null;
  const mrIntl = useTranslate()

  if (subjectId){
    if (!sourceValues.standard_collection_content_area_tag_ids || sourceValues.standard_collection_content_area_tag_ids) {
      finalRender = <FormRenderer
        sourceValues={sourceValues}
        formInstance={formInstance}
        formObj={getStandardCollectionContentAreaField(sourceValues, mrIntl)}
        propertyKey={("relation_items", "0")}
      />
    }
  }
  return finalRender;
}


const SelectRubricWidget = GenericWidgetCreator((props) => {
  console.log("SelectRubricWidget", props)
  const enabledFeatures = useSelector(enabledFeaturesSelector())
  let allowRubricChange = enabledFeatures.allow_rubric_change
  let hideCommentsOnlyRubric = false
  if (allowRubricChange) {
    hideCommentsOnlyRubric = (props.expRubricType === "myp_achievement_level" || props.expRubricType === "criteria_with_points") ? true : false
  }
  let params = {}
  let subjectId = props.formInstance.getFieldValue(["relation_items", "0", "subject_id"])
  params = {by_subject_id: subjectId }
  if(hideCommentsOnlyRubric){
    params.by_type_c_not = "comments_only"
  }
  return {config: {forceReload: true, params: params}}
}, SelectRubric);


const getRubricField = (sourceValues, mrIntl, expRubricType) => {
  console.log("getRubricField sourceValues", sourceValues)
  return {
    type: "object",
    properties: {
      rubric_id: {
        type: "string",
        title: mrIntl("ExperiencesCreateForm.rubric"),
        // title: "Rubric [Cannot be changed later]",
        placeholder: mrIntl("CommonText.select_rubric"),
        // placeholder: "Select rubric",
        widget: SelectRubricWidget,
        widgetConfig: {
          disabled: sourceValues.rubric_id && (expRubricType !== "myp_achievement_level" && expRubricType !== "criteria_with_points"),
          expRubricType: expRubricType
        },
        rules: [
          {
            required: true,
            message: mrIntl("CommonText.required_msg"),
          },
        ],
        setInitialValue: true,
      },
    }
  }
};

const RubricChildComponent = ({getFieldValue, sourceValues, formInstance, setFieldsValue}) => {
  console.log("RubricChildComponent sourceValues", sourceValues);
  const subjectId = getFieldValue(["relation_items", "0", "subject_id"]);
  const expRubricType = sourceValues && sourceValues.rubric && sourceValues.rubric.type_c
  
  let finalRender = null;
  const mrIntl = useTranslate()
  const enabledFeatures = useSelector(enabledFeaturesSelector())

  useEffect(() => {
    if(!subjectId){
      setFieldsValue({rubric_id: null})
    }
  }, [subjectId,setFieldsValue])
  if (subjectId){
    if (!sourceValues.rubric_id || (sourceValues.rubric_id && enabledFeatures.allow_rubric_change && (expRubricType === "myp_achievement_level" || expRubricType === "criteria_with_points"))) {
      finalRender = <FormRenderer
        // formObj={getSelectOrgSubjectField(sourceValues)}
        sourceValues={sourceValues}
        formInstance={formInstance}
        formObj={getRubricField(sourceValues, mrIntl, expRubricType)}
        // propertyKey={"settings"}
      />
    } else {
      finalRender = <Col style={{"marginBottom":"20px"}} span={6}>
        <Space direction="vertical">
          <span>{mrIntl("CommonText.selected_rubric")}: <b>{sourceValues.rubric.title}</b></span>
          {/* {sourceValues.rubric.criteria && <span>Criteria: <b>{JSON.stringify(sourceValues.rubric.criteria)}</b></span>} */}
        </Space>
      </Col>
      // finalRender = ""
    }
    // Done if rubric_id exists then dont show dropdown, just show simple show 
  }
  return finalRender;
}

const SelectGradeWidget = GenericWidgetCreator((props) => {
  return {config: {forceReload: true, params: {by_questionbank_id: props.formInstance.getFieldValue(["relation_items", "0", "questionbank_id"])}}}
}, SelectProgrammeGrade);


const getSelectGradeField = (sourceValues, mrIntl) => {
  return {
    type: "object",
    properties: {
      grade_id: {
        placeholder: mrIntl("CommonText.select_grade"),
        type: "string",
        span: 24,
        setInitialValue: true,
        widget: SelectGradeWidget,
        widgetConfig: {
          // disabled: sourceValues.relation_items && sourceValues.relation_items[0].grade_id ? true : false
          allowClear: false
        },
        rules: [
          {
            required: true,
            message: mrIntl("CommonText.required_msg"),
          },
        ]
      },
    }
  }
};

const GradeChildComponent = ({getFieldValue, sourceValues, formInstance}) => {
  const questionbankId = getFieldValue(["relation_items", "0", "questionbank_id"]);
  let finalRender = null;
  const mrIntl = useTranslate()
  if(questionbankId){
    finalRender = <FormRenderer
      formObj={getSelectGradeField(sourceValues, mrIntl)}
      sourceValues={sourceValues}
      formInstance={formInstance}
      propertyKey={"relation_items", "0"}
    />
  }
  return finalRender;
}

const SelectSubjectWidget = GenericWidgetCreator((props) => {
  return {config: {forceReload: true, params: {by_type_c: "group", by_questionbank_id: props.formInstance.getFieldValue(["relation_items", "0", "questionbank_id"])}}}
}, SelectProgrammeSubject);


const getSelectSubjectField = (sourceValues, mrIntl) => {
  console.log("getSelectSubjectField sourceValues", sourceValues)
  let restrictEditWithinSubjectGroup = sourceValues.relation_items && sourceValues.relation_items[0].subject_id && sourceValues.rubric.type_c !== 'points' ? true : false
  return {
    type: "object",
    properties: {
      subject_id: {
        placeholder: mrIntl("CommonText.select_subject"),
        type: "string",
        span: 24,
        setInitialValue: true,
        widget: SelectSubjectWidget,
        widgetConfig: {
          // disabled: sourceValues.relation_items && sourceValues.relation_items[0].subject_id ? true : false
          // TODO
          // disabled: sourceValues.relation_items && sourceValues.relation_items[0].subject_id && sourceValues.rubric.type_c != 'points' ? true : false
          // disabled is default false now but for myp restricting edit to within the same subject group
          restrictEditWithinSubjectGroup: restrictEditWithinSubjectGroup,
          allowClear: false,
        },
        rules: [
          {
            required: true,
            message: mrIntl("CommonText.required_msg"),
          },
        ]
      },
    }
  }
};

const SubjectChildComponent = ({getFieldValue, sourceValues, formInstance}) => {
  const questionbankId = getFieldValue(["relation_items", "0", "questionbank_id"]);
  let finalRender = null;
  const mrIntl = useTranslate()
  if(questionbankId){
    finalRender = <FormRenderer
      formObj={getSelectSubjectField(sourceValues, mrIntl)}
      sourceValues={sourceValues}
      formInstance={formInstance}
      propertyKey={"relation_items", "0"}
    />
  }
  return finalRender;
}


const SelectOrgGradeWidget = GenericWidgetCreator((props) => {
  return {config: {forceReload: true, params: {by_org_programme_id: props.formInstance.getFieldValue(["relation_items", "0", "org_programme_id"])}}}
}, SelectOrgGrade);


const getSelectOrgGradeField = (mrIntl) => {
  return {
    type: "object",
    properties: {
      grade_id: {
        title: mrIntl("CommonText.select_grade"),
        // title: mrIntl("CommonText.select_grade"),
        // title: "Select grade",
        type: "string",
        span: 24,
        setInitialValue: true,
        widget: SelectOrgGradeWidget,
        widgetConfig: {
          allowClear: false
        },
        rules: [
          {
            required: true,
            message: mrIntl("CommonText.required_msg"),
          },
        ]
      },
    }
  }
};

const OrgGradeChildComponent = ({getFieldValue, sourceValues, formInstance}) => {
  const orgProgrammeId = getFieldValue(["relation_items", "0", "org_programme_id"]);
  const mrIntl = useTranslate()
  // getIndex dynamically
  let finalRender = null;
  if(orgProgrammeId){
    finalRender = <FormRenderer
      formObj={getSelectOrgGradeField(mrIntl)}
      sourceValues={sourceValues}
      formInstance={formInstance}
      propertyKey={"relation_items", "0"}
    />
  }
  return finalRender;
}

const SelectOrgSubjectWidget = GenericWidgetCreator((props) => {
  return {config: {forceReload: true, params: {unarchived: true, by_org_programme_id: props.formInstance.getFieldValue(["relation_items", "0", "org_programme_id"])}}}
}, SelectOrgSubject);


const getSelectOrgSubjectField = (sourceValues, mrIntl) => {
  console.log("getSelectOrgSubjectField sourceValues", sourceValues)
  let restrictEditWithinSubjectGroup = sourceValues.relation_items && sourceValues.relation_items[0].subject_id && sourceValues.rubric.type_c !== 'points' ? true : false
  return {
    type: "object",
    properties: {
      subject_id: {
        // title: `Select subject ${restrictEditWithinSubjectGroup ? "[within same subject group]" : ""}`,
        title: restrictEditWithinSubjectGroup ? mrIntl("ExperienceCreateForm.select_subject_title") : mrIntl("CommonText.select_subject"),
        // title: `Select subject ${selectSubjectTitle}`,
        // title: "Select subject",
        type: "string",
        span: 24,
        setInitialValue: true,
        widget: SelectOrgSubjectWidget,
        widgetConfig: {
          // disabled: sourceValues.relation_items && sourceValues.relation_items[0].subject_id ? true : false
          // TODO
          // disabled: sourceValues.relation_items && sourceValues.relation_items[0].subject_id && sourceValues.rubric.type_c != 'points' ? true : false,
          // disabled is default false now but for myp restricting edit to within the same subject group
          restrictEditWithinSubjectGroup: restrictEditWithinSubjectGroup,
          allowClear: false,
        },
        rules: [
          {
            required: true,
            message: mrIntl("CommonText.required_msg"),
          },
        ]
        
      },
    }
  }
};

const OrgSubjectChildComponent = ({getFieldValue, sourceValues, formInstance}) => {
  const mrIntl = useTranslate();
  const orgProgrammeId = getFieldValue(["relation_items", "0", "org_programme_id"]);
  let finalRender = null;
  if(orgProgrammeId){
    finalRender = <FormRenderer
      formObj={getSelectOrgSubjectField(sourceValues, mrIntl)}
      sourceValues={sourceValues}
      formInstance={formInstance}
      propertyKey={"relation_items", "0"}
    />
  }
  return finalRender;
}

const SelectExperienceGroup = MrSelect({
  actions: genericActions,
  resourceName: "experiences",
  config: {
    url: "/experiences",
    params: {by_experience_type: "group"},
    processData: (data, props) => {
      return data.map((item) => {
        return {label: item.access_code + " (" + item.id + ") - " + item.name + " - " + item.status, value: item.id};
      });
    },
    searchApi: true,
    widgetConfig: {
      showSearch: true, 
      filterOption: true,
      optionFilterProp: "label",
      title: <MrTranslate id={"ExperienceCreateForm.select_experience"} />,
      placeholder: <MrTranslate id={"ExperienceCreateForm.select_experience"} />,
      style: {width: "400px"},
      allowClear: true
    },
  }
});

const PointsChildComponent = (props) => {
  console.log("PointsChildComponent", props);
  const { getFieldValue, sourceValues } = props;
  // const segmentType = getFieldValue(["segment_type"]);
  // const questionType = getFieldValue(["question_segment_attributes", "question_type"]);
  const mrIntl = useTranslate()
  const questionbankId = getFieldValue([
    "relation_items",
    "0",
    "questionbank_id",
  ]);
  const rubricId = getFieldValue(["rubric_id"]);
  const gradingSettingFormValue = getFieldValue([
    "settings",
    "grading_setting",
  ]);
  console.log("PointsChildComponent", rubricId);
  let rubric;

  let finalRender = null;
  // get active experience rubric = use criteria to build form for points if rubric not Points. if points or if no experience/adding segment in library, then default to below. if grading for full_experience then hide altogether

  // const activeExperienceId = useSelector(activeAdjustedExperienceIdSelector())
  // const activeExperience = useSelector(state => state.experiences.get("experiences").find((item) => item.id == activeExperienceId))
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const rubrics = useSelector(rubricsSelector());
  console.log(
    "PointsChildComponent",
    activeExperience,
    rubrics,
    questionbankId,
    rubricId,
    questionbankId && rubricId
  );

 
  if (activeExperience.rubric) {
    rubric = activeExperience.rubric;
  } else if (rubricId) {
    rubric = rubrics.find((r) => r.id === parseInt(rubricId));
  }
  if (!rubric) {
    return "";
  }
  if(gradingSettingFormValue !== "overall"){
    return "";
  }
  
  // // get active experience grading_setting = per_question/full_experience
  // if(activeExperience.settings.grading_setting == "overall"){
  //   finalRender = ""
  // }else{
  //   // if grading per question
  //   // change this to rubric_code

  if (rubric.type_c == "points") {
    finalRender = (
      <FormRenderer
        formObj={{
          type: "object",
          properties: {
            points: {
              type: "string",
              placeholder: mrIntl("CommonText.points"),
              setInitialValue: true,
              widget: InputNumber,
              rules: [
                {
                  validator(rule, value) {
                    if (value && value > 0) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(mrIntl("CommonText.not_allowed"));
                    }
                  },
                },
              ],
            },
          },
        }}
        // propertyKey={"section_segment_attributes"}
        sourceValues={sourceValues}
      />
    );
  } else if (
    rubric &&
    (rubric.type_c == "criteria_with_points" ||
      rubric.type_c == "myp_achievement_level" || rubric.type_c == "custom") &&
    rubric.criteria &&
    rubric.criteria.length != 0
  ) {
    finalRender = (
      <FormRenderer
        formObj={{
          type: "object",
          properties: {
            criterium_associations_attributes: {
              type: "string",
              placeholder: mrIntl("CommonText.points"),
              setInitialValue: true,
              widget: RubricCriteriaPointsForm,
              widgetConfig: {
                selectedRubric: rubric,
                associableType: "Experience",
              },
              rules: [
                // ({ getFieldValue }) => ({
                //   validator(rule, value) {
                //     if (!value || getFieldValue('password') === value) {
                //       return Promise.resolve();
                //     }
                //     return Promise.reject('The two passwords that you entered do not match!');
                //   },
                // }),
                {
                  validator(rule, value) {
                    console.log("Segment ca validator", value, typeof value);
                    let validationPassed = true;
                    let checkBoxValidationPassed = false;
                    let message = "Please select atleast one";
                    if (!value) {
                      validationPassed = false;
                    } else {
                      if (rubric.type_c == "criteria_with_points") {
                        for (let i = 0; i <= value.length - 1; i++) {
                          // check if atleast 1 is checked
                          let ca = value[i];
                          checkBoxValidationPassed = false;
                          // message = "Please select atleast one"
                          if (
                            ca.checked ||
                            (typeof ca.checked === "undefined" && ca.id)
                          ) {
                            // typeof and id condition for first time - when component isnt touched then checked doesn't get set since only on FE
                            checkBoxValidationPassed = true;
                            // console.log('Segment ca validator', validationPassed, ca.checked)
                            message = mrIntl("CommonText.passed_msg");
                            break;
                          }
                        }

                        // check if points valid
                        if (checkBoxValidationPassed) {
                          for (let i = 0; i <= value.length - 1; i++) {
                            let ca = value[i];
                            let updatedPoints = ca.points;
                            if (
                              updatedPoints &&
                              parseFloat(updatedPoints) > 0 &&
                              typeof parseFloat(updatedPoints) == "number" &&
                              updatedPoints.slice(-1) != "."
                            ) {
                              if (/[a-z]/gi.test(updatedPoints)) {
                                validationPassed = false;
                                message = mrIntl("ExperienceCreateForm.points_must_not_contain_any_letter");
                              }
                              // allowed
                            } else {
                              validationPassed = false;
                              message = mrIntl("ExperienceCreateForm.points_must_be_non_zero")
                              break;
                            }
                          }
                        } else {
                          validationPassed = false;
                          message = mrIntl("ExperienceCreateForm.please_select_atleast_one");
                        }
                      } else if (rubric.type_c == "myp_achievement_level") {
                        // console.log('Segment ca validator', ca, ca.checked)
                        for (let i = 0; i <= value.length - 1; i++) {
                          let ca = value[i];
                          // check if atleast 1 is checked
                          validationPassed = false;
                          message = mrIntl("ExperienceCreateForm.please_select_atleast_one");
                          if (
                            ca.checked ||
                            (typeof ca.checked === "undefined" && ca.id)
                          ) {
                            // typeof and id condition for first time - when component isnt touched then checked doesn't get set since only on FE
                            validationPassed = true;
                            // console.log('Segment ca validator', validationPassed, ca.checked)
                            message = mrIntl("CommonText.passed_msg");
                            break;
                          }
                        }
                      }
                      // })
                    }

                    console.log(
                      "UserResponses validator updatedPoints",
                      validationPassed
                    );
                    if (validationPassed) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(new Error(message));
                    }
                  },
                },
              ],
            },
          },
        }}
        // propertyKey={"section_segment_attributes"}
        sourceValues={sourceValues}
      />
    );
  }
  

  return finalRender;
};

const GradingSettingChildComponent = ({getFieldValue, sourceValues, formInstance, setFieldsValue}) => {
  const rubricId = getFieldValue(["rubric_id"]);
  console.log("GradingSettingChildComponent", rubricId);
  const rubrics = useSelector(rubricsSelector());
  const activeExperience = useSelector(activeAdjustedExperienceSelector())
  const mrIntl = useTranslate()
  let rubric, selectedRubric;
  if (!rubricId) {
    return "";
  }else{
    selectedRubric = rubrics.find((r) => r.id === parseInt(rubricId));
  }
  if(!isEmpty(activeExperience)){
    rubric = activeExperience.rubric
  }else{
    rubric = selectedRubric
  }

  if (!rubric) {
    return "";
  }

  let finalRender = null;
  
  if (rubricId && rubric.type_c === "custom"){
    finalRender = <FormRenderer
      sourceValues={sourceValues}
      formInstance={formInstance}
      propertyKey={"settings"}
      formObj={{
        type: "object",
        properties: {
          grading_setting: {
            type: "string",
            title: mrIntl("ExperienceCreateForm.apply_rubric_to_cannot_be_changed_later"),
            // placeholder: "Select rubric",
            widget: "RadioGroupWidget",
            default: "overall",
            // for now only supporting overall in custom
            // default: "per_question",
            widgetConfig: {
              disabled: sourceValues.settings && sourceValues.settings.grading_setting ? true : false,
              options: [
                // {
                //   label: "Each question",
                //   value: "per_question",
                // },
                {
                  label: mrIntl("ExperienceCreateForm.overall_assessment"),
                  value: "overall",
                },
              ],
            },
            rules: [
              {
                required: true,
                message: mrIntl("CommonText.required_msg"),
              },
            ],
            setInitialValue: true,
          },
        }
      }}
    />
  }
  return finalRender;
}

const generateExperienceCreateForm = (resourceName, props) => {
  console.log("line number 332",props);
  const { mrIntl } = props;

  // based on whether resource name is libraryexperience or experience, build below form to return
  // const { resourceName } = props
  const isMobile = checkMob()
  let org = props.org
  let currentUser = props.currentUser
  let formValues = props.formState.values
  let qbMode = (currentUser.role == "qb_author" && resourceName == "libraryexperience") ? true : false
  let createUpdateTags = qbMode
  let partnerName = props.partnerName
  let enabledFeatures = props.enabledFeatures

  let processFormData = (dataProps, opts) => {
    console.log("dataProps", dataProps);
    console.log("opts", opts);
    // process and set values and then return changed values
    // opts.values["custom_field"] = "custom_value";
    // let experience_memberships_attributes = []
    
    // opts.values.experience_memberships_attributes = experience_memberships_attributes;


    let relationItems = opts.values.relation_items[0]

    // We are using opts.formFinishProps.values because when we clear the value of a single select, the correct value does not appear in opts.value. APL-3541
    let formFinishPropsRelationItem =
      opts.formFinishProps.values.relation_items && opts.formFinishProps.values.relation_items[0];
    // not supporting multiple right now
    if(opts.values.settings.start_at_datetime) {
      opts.values.settings = {
        ...opts.values.settings,
        start_condition: "scheduled_time"
      }
    } else {
      opts.values.settings = {
        ...opts.values.settings,
        start_condition: "anytime"
      }
    }
    
    if(qbMode){
      let questionbank_items_attributes = []
      let qbi
      if(relationItems.questionbank_items && relationItems.questionbank_items.length != 0){
        qbi = relationItems.questionbank_items[0]
        qbi.questionbank_id = relationItems.questionbank_id
      }
      else{
        qbi = {
          itemable_type: "Experience",
          questionbank_id: relationItems.questionbank_id,
        }
      }
      questionbank_items_attributes.push(qbi)
      opts.values.questionbank_items_attributes = questionbank_items_attributes
    }else{
      let org_programme_items_attributes = []
      let opi
      if(relationItems.org_programme_items && relationItems.org_programme_items.length != 0){
        opi = relationItems.org_programme_items[0]
        opi.org_programme_id = relationItems.org_programme_id
      }
      else{
        opi = {
          itemable_type: "Experience",
          org_programme_id: relationItems.org_programme_id,
        }
      }
      org_programme_items_attributes.push(opi)
      opts.values.org_programme_items_attributes = org_programme_items_attributes
    }

    
    let subject_items_attributes = []
    let si
    if(relationItems.subject_items && relationItems.subject_items.length != 0){
      si = relationItems.subject_items[0]
      // si.subject_id = relationItems.subject_id
    }
    else{
      si = {
        itemable_type: "Experience",
        // subject_id: relationItems.subject_id,
      }
    }
    if(qbMode){
      si.programme_subject_id = relationItems.subject_id
    }else{
      si.subject_id = relationItems.subject_id
    }
    subject_items_attributes.push(si)
    opts.values.subject_items_attributes = subject_items_attributes

    let grade_items_attributes = []
    let gi
    if(relationItems.grade_items && relationItems.grade_items.length != 0){
      gi = relationItems.grade_items[0]
      // gi.grade_id = relationItems.grade_id
    }
    else{
      gi = {
        itemable_type: "Experience",
        // grade_id: relationItems.grade_id,
      }
    }
    if(qbMode){
      gi.programme_grade_id = relationItems.grade_id
    }else{
      gi.grade_id = relationItems.grade_id
    }
    grade_items_attributes.push(gi)
    opts.values.grade_items_attributes = grade_items_attributes


    if (createUpdateTags && relationItems) {
      // createUpdateSelectAttrsBeforeSubmit(<existing items>, <modified_ids>) // currently only for tag_items
      // let syllabus_items_attributes = createUpdateSelectAttrsBeforeSubmit(relationItems.syllabus_items, relationItems.syllabus_content_ids)
      // let difficulty_level_items_attributes = createUpdateSelectAttrsBeforeSubmit(relationItems.difficulty_level_items, relationItems.difficulty_level_tag_ids)
      let teaching_level_items_attributes = createUpdateSelectAttrsBeforeSubmit("Experience", formFinishPropsRelationItem.teaching_level_items, formFinishPropsRelationItem.teaching_level_tag_ids)
      let paper_type_items_attributes = createUpdateSelectAttrsBeforeSubmit("Experience", formFinishPropsRelationItem.paper_type_items, formFinishPropsRelationItem.paper_type_tag_ids)
      let standard_collection_content_area_items_attributes = createUpdateSelectAttrsBeforeSubmit("Experience", formFinishPropsRelationItem.standard_collection_content_area_items, formFinishPropsRelationItem.standard_collection_content_area_tag_ids)

      // console.log("tag_items_attributes", syllabus_items_attributes, difficulty_level_items_attributes, teaching_level_items_attributes)

      // opts.values.tag_items_attributes = syllabus_items_attributes.concat(difficulty_level_items_attributes).concat(teaching_level_items_attributes) 
      opts.values.tag_items_attributes = paper_type_items_attributes.concat(teaching_level_items_attributes).concat(standard_collection_content_area_items_attributes)
    }
    
    // console.log("getting from state and finding selectedSubject",relationItems.subject_id);
    // let selectedSubject = props.subjects.find(sub => sub.id === parseInt(relationItems.subject_id))
    // console.log("getting from state and finding selectedSubject",selectedSubject);
    
    // opts.values.custom_fields = {
    //   subjectItemLabel: selectedSubject.label
    // }
    
    // setting default to 1
    console.log("opts.values.settings.attempts_no", opts.values.settings.attempts_no)
    if(opts.values.settings.attempts_no == undefined){
      opts.values.settings.attempts_no = 1
    }
    
    if(qbMode){
      let allowEmbed = currentUser.role === "qb_author" ? true : false
      console.log("qbMode allowEmbed", allowEmbed)
      opts.values.settings.allow_embed = allowEmbed;
      
      // We are using opts.formFinishProps.values because when we clear the value of a single select, the correct value does not appear in opts.value.
      if(opts.formFinishProps.values.parent_id === undefined) {
        opts.values.parent_id = null
      }
    }
    
    console.log("opts.values exp create form process form data", opts.values)
    return opts.values;
  }
 
  // separate each and add to properties as needed based on resourceName or override
  let properties = {
    // Todo: add support for multiple select
    relation_items : {
      type: "array",
      span: 24,
      min: 1,
      max: 1,
      // max: qbMode ? 2 : 1, // allowing qb author to select multiple QB - not for now
      default: [{}],
      // default: [{org_programme_id: parseInt(getFromLS("activeOrgProgrammeId"))}],
      // set defaults from LS - hiding for now
      // title: "Relations",
      // widgetConfig: {
      //   disabled: props.formState.values.id ? true : false
      // },
      items: {
        type: "object",
        properties: {
          // questionbank_id: {
          //   placeholder: "Select questionbank",
          //   type: "string",
          //   span: 8,
          //   widget: SelectQuestionbank,
          // },

          // For schools to create test in school bank by default
          org_programme_id: {
            // title: "Select program",
            title: mrIntl("ExperiencesCreateForm.select_program"),
            type: "string",
            span: isMobile ? 24 : 6,
            widget: SelectProgram,
            widgetConfig: {
              disabled: formValues.relation_items && formValues.relation_items[0].org_programme_id ? true : false,
              allowClear: false
            },
            rules: [
              {
                required: true,
                message: mrIntl("CommonText.required_msg"),
                // message: 'Required',
              },
            ]
          },
          subject_id: {
            placeholder: mrIntl("CommonText.select_subject"),
            type: "string",
            span: isMobile ? 24 : 8,
            dependsOn: ["relation_items", "0", "org_programme_id"],
            children: OrgSubjectChildComponent,
            
          },
          grade_id: {
            placeholder: mrIntl("CommonText.select_grade"),
            type: "string",
            span: isMobile ? 24 : 4,
            dependsOn: ["relation_items", "0", "org_programme_id"],
            children: OrgGradeChildComponent,
            
          },
        },
        
      }
    },

    name: {
      type: "string",
      title: mrIntl("CommonText.title"),
      // title: "Title",
      span: isMobile ? 24 : 8,
      // widget: CKETextContent,
      rules: [
        {
          required: true,
          message: mrIntl("CommonText.required_msg"),
          // message: 'Required',
        },
        {
          max: 50,
          message: mrIntl("ExperienceCreateForm.max_50_characters"),
        },
      ]
    },
   

    // IMP
    // 1. Grade full test or per question // comments on by default for full test and per question
    // if grade full test, then give points input in exp form

    // 2. rubric -> For others: points/other rubric -> single select
    // 2. rubric -> FOr MYP: myp criteria with points/myp achievement level/other rubric -> single select

    // only use to show per question -> attach only those that are used in questions. If other rubric, then show another dropnwod to select from rubrics of that prog/sub/grade -> 


    rubric_id: {
      type: "string",
      span: isMobile ? 24 : 24,
      title: mrIntl("ExperienceCreateForm.rubric"),
      widget: SelectRubric,
      dependsOn: ["relation_items", "0", "subject_id"],
      // shouldUpdate: decideIfUpdate(),
      // shouldUpdate: false,
      children: RubricChildComponent,
      widgetConfig: {
        disabled: formValues.rubric_id ? true : false
      },
      // rules: [
      //   {
      //     required: true,
      //     message: 'Required',
      //   },
      // ]
    },

    // Comment for now update latter because of this when we edit the assessment the points show and need to check why points show REF. Ticket: APL-3458
    // points: {
    //   type: "string",
    //   placeholder: mrIntl("CommonText.points"),
    //   // span: 4,
    //   span: 16,
    //   wrapClassName: "wrap-segment-form-points",
    //   // dependsOn: ["segment_type"],
    //   // children: qbMode ? PointsChildComponentTempLibrary : PointsChildComponent,
    //   dependsOn: ["rubric_id"],
    //   children: PointsChildComponent,
    //   // // setInitialValue: true,
    //   rules: [
    //     {
    //       required: true,
    //       message: mrIntl("CommonText.required_msg"),
    //     },
    //   ],
    // },

    // criterium_associations: {
    //   type: "string",
    //   span: isMobile ? 24 : 24,
    //   title: "Criteria",
    //   // dependsOn: ["rubric_id"],
    //   // children: RubricChildComponent,
    //   // widgetConfig: {
    //   //   disabled: formValues.rubric_id ? true : false
    //   // },
    //   widget: "CheckboxGroupWidget",
    //   widgetConfig: {
    //     options: buildOptionsArr(['A: Knowledge', 'B: Application'])
    //   },
    //   // rules: [
    //   //   {
    //   //     required: true,
    //   //     message: 'Required',
    //   //   },
    //   // ]
    // },

    settings: {
      type: "object",
      properties: {
        grading_setting: {
          type: "string",
          span: 24,
          // title: "Apply rubric to",
          // widget: "RadioGroupWidget",
          // default: "per_question",
          // widgetConfig: {
          //   disabled: formValues.settings && formValues.settings.grading_setting ? true : false,
          //   options: [
          //     {
          //       label: "Each question",
          //       value: "per_question",
          //     },
          //     {
          //       label: "Overall assessment",
          //       value: "overall",
          //     },
          //   ],
          // },
          dependsOn: ["rubric_id"],
          children: GradingSettingChildComponent,
        },

        

        // grading_type: {
        //   type: "string",
        //   span: 24,
        //   title: "Grading",
        //   widget: "RadioGroupWidget",
        //   default: "points",
        //   widgetConfig: {
        //     options: [
        //       {
        //         label: "Points",
        //         value: "points",
        //       },
        //       // {
        //       //   label: "Achievement level",
        //       //   value: "level",
        //       // },
        //       // {
        //       //   label: "Other rubric",
        //       //   value: "other",
        //       // },
        //     ],
        //   },
        // },
        mode: {
          type: "string",
          title: mrIntl("ExperiencesCreateForm.delivery_mode"),
          // title: "Delivery mode",
          widget: "RadioGroupWidget",
          default: "online",
          span: isMobile ? 24 : 24,
          rules: [
            {
              required: true,
              message: mrIntl("CommonText.required_msg"),
            },
          ],
          widgetConfig: {
            options: getExperienceModeOptionsForForm({partnerName: partnerName}, mrIntl),
            // disabled: true
            // optionType: "button",
            // buttonStyle: "solid",
          },
        },
        start_at_datetime: {
          // title: "Start date and time",
          title: mrIntl("CommonText.start_date_and_time"),
          type: "string",
          span: isMobile ? 24 : 12,
          widget: "DatePickerWidget",
          widgetConfig: {
            format: "YYYY-MM-DD h:mm a",
            // showTime: true,
            showTime: {use12Hours: true, format:"h:mm a", minuteStep: 15},
            disabledDate: (current) => {
              let dd = dayjs().startOf('day').isAfter(current, 'day') || dayjs().add(3, 'month').startOf('day').isBefore(current, 'day')
              return dd;
            }                        
          }
        },
      }
    },
  }

  if(qbMode || enabledFeatures.allow_select_assessment_type){
    properties.settings.properties.assessment_type = {
      type: "string",
      title: mrIntl("ExperienceCreateForm.assessment_type_for_pamoja_authors"),
      widget: "RadioGroupWidget",
      default: "exam",
      span: isMobile ? 24 : 24,
      widgetConfig: {
        options: getAssessmentTypeOptionsForForm(mrIntl),
        // disabled: true
        // optionType: "button",
        // buttonStyle: "solid",
      },
    }
  }
  if (enabledFeatures.allow_select_evaluation_type || process.env.REACT_APP_MODE !== "production") {
    properties.settings.properties.evaluation_type = {
      type: "string",
      title: mrIntl("CommonText.evaluation_type"),
      widget: "RadioGroupWidget",
      default: "formative",
      span: isMobile ? 24 : 24,
      rules: [
        {
          required: true,
          message: mrIntl("CommonText.required_msg")
        },
      ],
      widgetConfig: {
        options: [{ label: mrIntl("CommonText.formative"), value: 'formative' }, { label: mrIntl("CommonText.summative"), value: 'summative' }],
        // disabled: true
        // optionType: "button",
        // buttonStyle: "solid",
      },
    };
  }

  if(qbMode){
    properties.relation_items.items.properties = {
      // For qb_author to create test in qb
      questionbank_id: {
        // placeholder: "Select questionbank",
        placeholder: mrIntl("CommonText.select_questionbank"),
        type: "string",
        span: 8,
        widget: SelectQuestionbank,
        widgetConfig: {
          disabled: formValues.relation_items && formValues.relation_items[0].questionbank_id ? true : false
        },
        rules: [
          {
            required: true,
            message: mrIntl("CommonText.required_msg"),
          },
        ]
      },
      subject_id: {
        placeholder: mrIntl("CommonText.select_subject"),
        type: "string",
        span: 8,
        dependsOn: ["relation_items", "0", "questionbank_id"],
        children: SubjectChildComponent,
      },
      grade_id: {
        placeholder: mrIntl("CommonText.select_grade"),
        type: "string",
        span: 4,
        dependsOn: ["relation_items", "0", "questionbank_id"],
        children: GradeChildComponent,
      },
    }
    properties.relation_items.items.properties.paper_type_tag_ids = {
      placeholder: mrIntl("ExperienceCreateForm.select_paper_type"),
      type: "string",
      span: 8,
      widget: SelectPaperType,
      widgetConfig: {
        type_c: "paper_type"
      },
    };
    properties.relation_items.items.properties.teaching_level_tag_ids = {
      // placeholder: "Select teaching level",
      placeholder: mrIntl("ExperienceCreateForm.select_teaching_level"),
      type: "string",
      span: 8,
      widget: SelectTeachingLevel,
      widgetConfig: {
        type_c: "teaching_level"
      },
    };
    properties.relation_items.items.properties.standard_collection_content_area_tag_ids = {
      // placeholder: "Select teaching level",
      placeholder: mrIntl("ExperienceCreateForm.select_teaching_level"),
      type: "string",
      span: 8,
      dependsOn: ["relation_items", "0", "subject_id"],
      children: SelectStandardCollectionContentAreaChildComponent,
      widgetConfig: {
        type_c: "content_area"
      },
    };

    // Only for pamoja authors
    // properties.settings.properties.assessment_type = {
    //   type: "string",
    //   title: "Assessment type [For Pamoja authors only - Quick check for auto-grading and auto-publishing, Exam for teaching-graded and manual publishing of submissions]",
    //   widget: "RadioGroupWidget",
    //   default: "exam",
    //   span: isMobile ? 24 : 24,
    //   widgetConfig: {
    //     options: getAssessmentTypeOptionsForForm(),
    //     // disabled: true
    //     // optionType: "button",
    //     // buttonStyle: "solid",
    //   },
    // }
    // Below being used for DP bank
    properties.experience_type = {
      type: "string",
      title: mrIntl("ExperienceCreateForm.experience_type"),
      widget: "RadioGroupWidget",
      default: "assessment",
      span: isMobile ? 24 : 24,
      rules: [
        {
          required: true,
          message: mrIntl("CommonText.required_msg"),
        },
      ],
      widgetConfig: {
        options: [
          {
            label: mrIntl("ExperienceCreateForm.assessment"),
            value: "assessment",
          },
          {
            label: mrIntl("ExperienceCreateForm.learning"),
            value: "learning",
            disabled: true
          },
          {
            label: mrIntl("CommonText.group"),
            value: "group",
          },
        ],
        // disabled: true
        // optionType: "button",
        // buttonStyle: "solid",
      },
    }
    properties.parent_id = {
      type: "string",
      span: 12,
      placeholder: mrIntl("ExperienceCreateForm.select_group"),
      title: "Select group",
      widget: SelectExperienceGroup,
      widgetConfig: {
        title: mrIntl("ExperienceCreateForm.select_group"),
        placeholder: mrIntl("ExperienceCreateForm.select_group"),
      }
    }
    properties.custom_fields = {
      type: "object",
      properties: {
        ib_reference_code: {
          type: "string",
          span: 24,
          placeholder: mrIntl("CommonText.ib_reference_code"),
          title: <MrTranslate id={"CommonText.ib_reference_code"}/>,
        },
        show_in_osc: {
          type: "string",
          span: 24,
          placeholder: mrIntl("ExperienceCreateForm.show_in_osc"),
          // title: "Show in OSC",
          widget: CustomSwitchWidget,
          valuePropName: "checked",
        },
        is_new: {
          type: "string",
          span: 24,
          placeholder: mrIntl("ExperienceCreateForm.is_new"),
          // title: "Show in OSC",
          widget: CustomSwitchWidget,
          valuePropName: "checked",
        }
      }
    }
  }

  let finalForm = {
    processFormData: processFormData,
    schema: {
      type: "object",
      properties: properties,
    }
  }

  return finalForm;

}




export default generateExperienceCreateForm;